import { de } from './de';
import { en } from './en';

export const defaultLocale = 'de';

export const messages = {
    de,
    en,
}
